import React, { useState } from 'react';
import styled from 'styled-components';
import { media } from 'utils/style';
import { useTranslation } from 'react-i18next';
import { CountryContactRow } from './CountryContactRow';
import XPOPhone from 'assets/icons/xpo/phone.svg';
import XPOArrowTipDown from 'assets/icons/xpo/arrowtip-down.svg';

const LandingContact = styled.div`
  display: block;
  position: absolute;
  bottom:0;
  width: 100%;
  z-index: 999;
  overflow: hidden;
  ${media.lessThan('small')`
    margin-bottom:48px;
  `};
`;

const LandingContactContainer = styled.div`
  bottom:0;
  width: 100%;
  background-color: #CC0000;
  height: 48px;
  cursor: pointer;
  vertical-align: middle;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  white-space:nowrap;
  ${media.lessThan('extraSmall')`
    flex-direction: column;
  `};
`;

const LandingContactTitle = styled.label`
  display: inline;
  align-self: center;
  color: var(--white);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  cursor: pointer;
  width: auto;
  padding:1px 10px;
`;

const LandingContactDropoff = styled.label`
  display: block;
  align-self: center;
  float:left;
  color: var(--white);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  cursor: pointer;
  width: auto;
  padding:1px 10px;
  &::before {
    content: '';
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 10px;
    margin-bottom:-3px;
    background-image: url(${XPOPhone});
    background-size: contain;
    background-repeat: no-repeat;
  }
  &::after {
    content: '';
    display: inline-block;
    width: 9px;
    height: 9px;
    margin-left: 12px;
    background-image: url(${XPOArrowTipDown});
    background-size: contain;
    background-repeat: no-repeat;
  }
`;

const LandingContactCountriesContainer = styled.div`
  display: ${props => (props.isVisible ? 'block' : 'none')};
  width: 100%;
  height: auto;
  padding: 8px 0 16px 0;
  text-align: center;
  background-color: var(--grey100);
`;

export const Contact = () => {
    const { t } = useTranslation('Landing');
  
    const [isActive, setIsActive] = useState(false);
  
    const handleParentButtonClick = () => {
      setIsActive(!isActive);
    };
  
    return (
      <LandingContact>
        <LandingContactContainer isActive={isActive} onClick={handleParentButtonClick}>
          <LandingContactTitle>{t('contact.title')}</LandingContactTitle>  
          <LandingContactDropoff>
          {t('contact.subtitle')}
          </LandingContactDropoff> 
        </LandingContactContainer>
        <LandingContactCountriesContainer isVisible={isActive}>
          <CountryContactRow flag="FR" number={t('contact.number_fr')} mail={t('contact.mail_fr')} />
          <CountryContactRow flag="RO" number={t('contact.number_ro')} mail={t('contact.mail_ro')} />
          <CountryContactRow flag="PL" number={t('contact.number_pl')} mail={t('contact.mail_pl')} />
          <CountryContactRow flag="ES" number={t('contact.number_es')} mail={t('contact.mail_es')} />
        </LandingContactCountriesContainer>
      </LandingContact>
    );
  };